import {
    addSingleCourseTerm,
    cancelClientOrderByOffice,
    cancelCourseById,
    cancelCourseTermById,
    cancelLectureAttendeeReservationById,
    cancelLectureTermById,
    cancelMyCourseSessionReservationById,
    cancelMyLectureTermReservationById,
    cancelMyLectureTermReservationByPublicCode,
    cancelRepeatedLectureTermsById,
    cancelWorkshopById,
    createOfficeCourse,
    createOfficeLectureInstance,
    createOfficeWorkshop,
    deleteDraftByLectureId,
    deleteOfficeLectureType,
    publishDraftByLectureId,
    sendMessageToClient,
    sendSummaryMessage,
    updateAttendeeIsPresentAndPaymentIsCompleteByReservationId,
    updateAttendeeNotPresentAndPaymentIsNotPaidByReservationId,
    updateCourseAndItsTermsById,
    updateLectureType,
    updateOfficeCanceledLectureTermVisibilityById,
    updateOfficeLectureTermById,
    updateOfficeWorkshop,
    updateOfficeWorkshopVisibilityById,
    updateReservationById,
} from './mutation/lectures';
import {
    addCreditEntryByOffice,
    addMakeUpSessionEntryByOffice,
    addPassEntryByOffice,
    cancelScheduledStripeSubscription,
    changeCreditEntryValidityByOffice,
    changePassEntryValidityByOffice,
    createAddress,
    createClient,
    createClientLabel,
    createClientNote,
    createEcomailIntegration,
    createEmployee,
    createMailerliteIntegration,
    createOfficeCancellationPolicyTemplate,
    createOfficeEntryCredit,
    createOfficeEntryPass,
    createOfficeLectureTemplate,
    createOfficeMembership,
    createOfficePaymentMethod,
    createOfficeTerms,
    createOrganisationLicensePayment,
    createOrganisationSmsPackagePayment,
    createPromoCode,
    createSmartemailingIntegration,
    createVoucher,
    decreaseCreditEntryByOffice,
    decreasePassEntryByOffice,
    deleteClientLabel,
    deleteOfficeCancellationPolicy,
    deleteOfficeEmployeeById,
    deleteOfficeEntryCredit,
    deleteOfficeEntryPass,
    deleteOfficeLectureTemplateById,
    deleteOfficePaymentMethodById,
    deleteOrgLabel,
    deleteOrganisationClientById,
    deletePromoCodeById,
    deleteVoucherById,
    leaveMyOfficeEmploymentById,
    modifyOtherOfficeCurrency,
    removeMakeUpSessionEntryByOffice,
    revokeMailchimpIntegration,
    updateAddressById,
    updateBillingAddressById,
    updateBillingInfoForClientById,
    updateClientById,
    updateClientOfficeDataById,
    updateClientOrderByOffice,
    updateConfigByOfficeId,
    updateEcomailIntegration,
    updateMailchimpIntegration,
    updateMailerliteIntegration,
    updateOfficeById,
    updateOfficeCancellationPolicyTemplate,
    updateOfficeEmployeeById,
    updateOfficeEntryCredit,
    updateOfficeEntryPass,
    updateOfficeLectureTemplateById,
    updateOfficeNotificationConfigByOfficeId,
    updateOfficePaymentMethod,
    updatePromoCode,
    updateSmartemailingIntegration,
    updateStripeSubscriptionPayment,
} from './mutation/offices';
import {
    createOrganisation,
    createOrganisationForCompletedUser,
    createOrganisationOnboarding,
    removeOrganisationById,
    updateOrganisationById,
    updateOrganisationLicense,
} from './mutation/organisations';
import { createOfficePlace, deleteOfficePlaceById, updateOfficePlaceById } from './mutation/places';
import {
    createCourseOrder,
    createNotRegisteredUserReservation,
    createRegisteredUserMakeUpReservation,
    createRegisteredUserReservation,
    createReservationByOffice,
    createWorkshopOrder,
    createWorkshopOrderByOffice,
} from './mutation/reservation';
import { createWaitlistNotification } from './mutation/system';
import {
    buyCredit,
    buyEntryPass,
    buyVoucher,
    changeUserPassword,
    claimVoucher,
    createOrganisationUser,
    createUser,
    createUserPassword,
    resetPassword,
    updateOrganisationUser,
    updateUserById,
} from './mutation/users';
import {
    getAllCourseTermsByLectureId,
    getAttendeesByLectureTermId,
    getCourseAttendeesByCourseId,
    getCourseTermsCapacities,
    getFutureLectureTermsByLectureId,
    getMyLectures,
    getMyOfficeLectures,
    getMyWorkshops,
    getOfficeLectureTermById,
    getOfficeLectures,
    getOfficePrivateLecturesByDatetimeRange,
    getOfficePublicLecturesByDatetimeRange,
    getOfficePublicLecturesDates,
    getPrivateLectureByGraphQlId,
    getPublicAttendeesByLectureTermId,
    getPublicCourseAttendeesByCourseId,
    getPublicLectureTermByGraphQlId,
    getReservationsByLectureIdAndUserId,
    getTermOnlineData,
    getWaitlistNotificationAttendeesByLectureTermId,
    getWorkshopsReservationsByUserId,
} from './query/lectures';
import {
    getActiveEmployeeByOfficeId,
    getAddressByOfficeId,
    getCancellationPolicyTemplatesByOfficeId,
    getClientByEmailAndOfficeId,
    getClientOrderByIdAndOfficeId,
    getClientOrdersByOfficeId,
    getClientsByNameAndOfficeId,
    getClientsByOfficeId,
    getEmployeesByOfficeId,
    getLectureTemplatesByOfficeId,
    getLectureTermBulkMessages,
    getOfficeByDomain,
    getOfficeClientById,
    getOfficeClientLabelsByClientId,
    getOfficeConfigById,
    getOfficeEcomailIntegrationByOfficeId,
    getOfficeEntryCreditsByOfficeId,
    getOfficeEntryPassesByOfficeId,
    getOfficeIncomeStatistics,
    getOfficeLabels,
    getOfficeMailchimpIntegrationByOfficeId,
    getOfficeMailerLiteIntegrationByOfficeId,
    getOfficeNotificationConfigByOfficeId,
    getOfficePaymentMethods,
    getOfficeSmartemailingIntegrationByOfficeId,
    getOfficeStatisticsActual,
    getOfficeStatisticsRevenue,
    getOfficeWithConfigByOfficeGraphQlId,
    getOfficeWithConfigByOfficeId,
    getPrivateCourseDetailByIdAndOfficeId,
    getPrivateWorkshopDetailByOfficeId,
    getPrivateWorkshopsByOfficeId,
    getPromoCodesByOfficeId,
    getPublicCourseClientOrderById,
    getPublicCourseDetailByIdAndOfficeId,
    getPublicCoursesByOfficeId,
    getPublicCoursesOverviewWithoutTermsByOfficeId,
    getPublicFreelancerByOfficeId,
    getPublicStudioByOfficeId,
    getPublicWorkshopClientOrderById,
    getPublicWorkshopDetailByOfficeId,
    getPublicWorkshopsByOfficeId,
    getShowCoursesAndWorkshopsForOfficeId,
    getSupportedCurrencies,
    getTermsByOfficeId,
    getUsersWithActiveCreditOrPassByOffice,
    getWorkshopBulkMessages,
    vouchersByOfficeId,
} from './query/offices';
import {
    getOfficeLicensePaymentMethodsByOfficeId,
    getOrganisationById,
    getOrganisationLabelsById,
    getOrganisationLicensePaymentsById,
    getOrganisationSmsPackagesOrdersById,
    getOrganisations,
} from './query/organisations';
import { getOfficePlaceById, getPlacesByOfficeId } from './query/places';
import { checkTokenExist, checkWaitlistNotificationExist, getTariffs } from './query/system';
import {
    getClientByUserIdAndOfficeId,
    getClientOffice,
    getClientOfficeByUserIdAndOfficeId,
    getClientOfficeByUserIdAndOfficeIdRequestedByEmployee,
    getClientmentsByUserId,
    getEmploymentByUserIdAndOfficeDomain,
    getEmploymentByUserIdAndOfficeId,
    getEmploymentsByUserId,
    getOfficeEmploymentsByUserIdForDropdown,
    getOrganisationSingleUser,
    getReservationByReservationToken,
    getReservationsByClientId,
    getReservationsByUserId,
    getUserByEmail,
    getUserById,
    getUserOrderById,
    getUserOrders,
    getUserVouchers,
} from './query/users';
import {
    clientCreated,
    officeEmployeeRemoved,
    officeNotificationConfigUpdated,
    officePaymentMethodsUpdated,
    orderPaymentsUpdated,
    organisationLastOrganisationLicensePaymentUpdated,
    tariffLimitsUpdate,
} from './subscription';

export const fyoogaMutations = {
    createAddress,
    createOrganisationLicensePayment,
    updateStripeSubscriptionPayment,
    cancelScheduledStripeSubscription,
    createOrganisationSmsPackagePayment,
    createOfficeLectureInstance,
    createOfficeCourse,
    createOfficeWorkshop,
    updateOfficeWorkshop,
    deleteOfficeLectureType,
    cancelLectureAttendeeReservationById,
    cancelClientOrderByOffice,
    cancelMyCourseSessionReservationById,
    cancelMyLectureTermReservationById,
    cancelMyLectureTermReservationByPublicCode,
    updateReservationById,
    updateAttendeeIsPresentAndPaymentIsCompleteByReservationId,
    updateAttendeeNotPresentAndPaymentIsNotPaidByReservationId,
    deleteClientLabel,
    deleteOrgLabel,
    updateLectureType,
    updateOfficeLectureTermById,
    updateOfficeCanceledLectureTermVisibilityById,
    updateOfficeWorkshopVisibilityById,
    updateCourseAndItsTermsById,
    addSingleCourseTerm,
    sendSummaryMessage,
    sendMessageToClient,
    updateAddressById,
    updateBillingAddressById,
    updateOfficeNotificationConfigByOfficeId,
    createOfficeTerms,
    createOrganisation,
    createOfficePlace,
    updateOfficePlaceById,
    updateOfficeEmployeeById,
    deleteOfficePlaceById,
    createOrganisationUser,
    createUser,
    createUserPassword,
    createOrganisationOnboarding,
    createOrganisationForCompletedUser,
    updateOrganisationLicense,
    changeUserPassword,
    resetPassword,
    updateOrganisationUser,
    createOfficeLectureTemplate,
    updateClientById,
    updateBillingInfoForClientById,
    deleteOrganisationClientById,
    deletePromoCodeById,
    deleteVoucherById,
    updateClientOfficeDataById,
    deleteOfficeEmployeeById,
    leaveMyOfficeEmploymentById,
    updateUserById,
    deleteOfficeLectureTemplateById,
    createClient,
    createOfficeMembership,
    createSmartemailingIntegration,
    createMailerliteIntegration,
    createEcomailIntegration,
    updateSmartemailingIntegration,
    updateMailerliteIntegration,
    updateEcomailIntegration,
    revokeMailchimpIntegration,
    updateMailchimpIntegration,
    createClientNote,
    createClientLabel,
    createEmployee,
    updateOfficeById,
    createNotRegisteredUserReservation,
    createRegisteredUserReservation,
    createRegisteredUserMakeUpReservation,
    createReservationByOffice,
    createWorkshopOrderByOffice,
    createOfficeCancellationPolicyTemplate,
    updateOfficeCancellationPolicyTemplate,
    deleteOfficeCancellationPolicy,
    updateConfigByOfficeId,
    createOfficeEntryPass,
    createOfficeEntryCredit,
    updateOfficeEntryPass,
    deleteOfficeEntryPass,
    updateOfficeEntryCredit,
    deleteOfficeEntryCredit,
    updateOfficeLectureTemplateById,
    publishDraftByLectureId,
    deleteDraftByLectureId,
    cancelLectureTermById,
    cancelCourseTermById,
    cancelWorkshopById,
    cancelRepeatedLectureTermsById,
    cancelCourseById,
    buyEntryPass,
    buyVoucher,
    claimVoucher,
    createWorkshopOrder,
    createCourseOrder,
    buyCredit,
    updateClientOrderByOffice,
    addCreditEntryByOffice,
    removeMakeUpSessionEntryByOffice,
    addMakeUpSessionEntryByOffice,
    addPassEntryByOffice,
    decreaseCreditEntryByOffice,
    decreasePassEntryByOffice,
    changeCreditEntryValidityByOffice,
    changePassEntryValidityByOffice,
    createWaitlistNotification,
    updateOfficePaymentMethod,
    createOfficePaymentMethod,
    deleteOfficePaymentMethodById,
    updateOrganisationById,
    removeOrganisationById,
    getOfficeStatisticsRevenue,
    getOfficeStatisticsActual,
    modifyOtherOfficeCurrency,
    createPromoCode,
    updatePromoCode,
    createVoucher,
};

export const fyoogaQueries = {
    getAttendeesByLectureTermId,
    getWaitlistNotificationAttendeesByLectureTermId,
    getCourseAttendeesByCourseId,
    getPublicAttendeesByLectureTermId,
    getPublicCourseAttendeesByCourseId,
    getCourseTermsCapacities,
    getAddressByOfficeId,
    getTermsByOfficeId,
    getOrganisations,
    getOrganisationLabelsById,
    getPlacesByOfficeId,
    getOfficePlaceById,
    getOrganisationSingleUser,
    getClientsByNameAndOfficeId,
    getLectureTermBulkMessages,
    getWorkshopBulkMessages,
    getClientByEmailAndOfficeId,
    getOfficeLectures,
    getMyOfficeLectures,
    getMyLectures,
    getMyWorkshops,
    getWorkshopsReservationsByUserId,
    getTariffs,
    getUserById,
    getUserByEmail,
    getUserOrders,
    getUserOrderById,
    getOrganisationById,
    getOfficeLicensePaymentMethodsByOfficeId,
    getOrganisationLicensePaymentsById,
    getOrganisationSmsPackagesOrdersById,
    getOfficeByDomain,
    getOfficeLabels,
    getShowCoursesAndWorkshopsForOfficeId,
    getSupportedCurrencies,
    getOfficeWithConfigByOfficeId,
    getOfficeWithConfigByOfficeGraphQlId,
    getClientsByOfficeId,
    getPromoCodesByOfficeId,
    getPrivateWorkshopsByOfficeId,
    getPublicWorkshopsByOfficeId,
    getPublicCoursesByOfficeId,
    getPublicCoursesOverviewWithoutTermsByOfficeId,
    getPublicCourseDetailByIdAndOfficeId,
    getPrivateCourseDetailByIdAndOfficeId,
    getPrivateWorkshopDetailByOfficeId,
    getPublicWorkshopDetailByOfficeId,
    getClientOrdersByOfficeId,
    getClientOrderByIdAndOfficeId,
    getPublicWorkshopClientOrderById,
    getPublicCourseClientOrderById,
    getOfficeClientById,
    getOfficeClientLabelsByClientId,
    getEmployeesByOfficeId,
    getPublicFreelancerByOfficeId,
    getPublicStudioByOfficeId,
    getActiveEmployeeByOfficeId,
    getLectureTemplatesByOfficeId,
    getOfficePublicLecturesByDatetimeRange,
    getOfficePublicLecturesDates,
    getOfficePrivateLecturesByDatetimeRange,
    getPrivateLectureByGraphQlId,
    getOfficeLectureTermById,
    getPublicLectureTermByGraphQlId,
    getClientByUserIdAndOfficeId,
    getUserVouchers,
    getCancellationPolicyTemplatesByOfficeId,
    getOfficeConfigById,
    getReservationsByUserId,
    getReservationsByClientId,
    getReservationByReservationToken,
    getClientmentsByUserId,
    getClientOfficeByUserIdAndOfficeId,
    getClientOfficeByUserIdAndOfficeIdRequestedByEmployee,
    getClientOffice,
    getEmploymentsByUserId,
    getOfficeEmploymentsByUserIdForDropdown,
    getEmploymentByUserIdAndOfficeId,
    getEmploymentByUserIdAndOfficeDomain,
    getOfficeEntryPassesByOfficeId,
    getOfficeNotificationConfigByOfficeId,
    getOfficeSmartemailingIntegrationByOfficeId,
    getOfficeMailerLiteIntegrationByOfficeId,
    getOfficeEcomailIntegrationByOfficeId,
    getOfficeMailchimpIntegrationByOfficeId,
    getOfficeEntryCreditsByOfficeId,
    getOfficePaymentMethods,
    getReservationsByLectureIdAndUserId,
    checkTokenExist,
    checkWaitlistNotificationExist,
    getUsersWithActiveCreditOrPassByOffice,
    getOfficeStatisticsRevenue,
    getOfficeStatisticsActual,
    getOfficeIncomeStatistics,
    getTermOnlineData,
    getFutureLectureTermsByLectureId,
    getAllCourseTermsByLectureId,
    vouchersByOfficeId,
};

export const fyoogaSubscriptions = {
    clientCreated,
    officeEmployeeRemoved,
    tariffLimitsUpdate,
    officeNotificationConfigUpdated,
    organisationLastOrganisationLicensePaymentUpdated,
    officePaymentMethodsUpdated,
    orderPaymentsUpdated,
};
